import ChevronDown16 from '@carbon/icons-react/es/chevron--down/16';
import { Dropdown } from 'antd';
import { snakeCase } from 'lodash';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SlackNotificationEvent } from 'api/integrations/slack/slack.types';
import { ReminderOption } from 'api/notifications/configuration';
import { Menu } from 'components/atoms/dropdown';
import { Trigger } from 'components/organisms/notifications/common';

interface Props {
  onNotificationChange: (notifications: SlackNotificationEvent[]) => void;
  notification: SlackNotificationEvent;
}

export const ReminderPicker: React.FC<Props> = ({
  notification,
  onNotificationChange,
}) => {
  return (
    <Dropdown
      trigger={['click']}
      overlay={
        <Menu
          selectable
          selectedKeys={[notification.meta?.type ?? ReminderOption.SameDay]}
          onSelect={({ key }) => {
            onNotificationChange([
              {
                ...notification,
                meta: { type: key as ReminderOption },
              },
            ]);
          }}
        >
          {Object.keys(ReminderOption)
            .map((x) => x as ReminderOption)
            .map((reminder) => (
              <Menu.Item key={reminder}>
                <FormattedMessage
                  id={`notifications.configuration.reminder_options.${snakeCase(
                    reminder,
                  )}`}
                />
              </Menu.Item>
            ))}
        </Menu>
      }
    >
      <Trigger>
        <FormattedMessage
          id={`notifications.configuration.reminder_options.${snakeCase(
            notification?.meta?.type ?? ReminderOption.SameDay,
          )}`}
        />
        <ChevronDown16 />
      </Trigger>
    </Dropdown>
  );
};
